import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.matchings.NetSuiteMatchingInfo.Content', {
    billColumnName: 'Bill',
    totalAmount: 'Total amount: {totalAmount}',
    dateColumnName: 'Date',
    categoryColumnName: 'Category',
    accountColumnName: 'Account',
    taxCodeColumnName: 'Tax code',
    taxRateColumnName: 'Tax rate',
    taxAmountColumnName: 'Tax amount',
    grossAmountColumnName: 'Gross amount',
    memoColumnName: 'Memo',
    departmentColumnName: 'Department',
    classColumnName: 'Class',
    locationColumnName: 'Location',
    isBillableColumnName: 'Billable',
    descriptionColumnName: 'Description',
    quantityColumnName: 'Qty',
    itemColumnName: 'Item',
    customerColumnName: 'Customer',
    amountColumnName: 'Amount',
    unitPriceColumnName: 'Rate',
    emptyMatching: 'No matching found',
    deleteConfirmationText: 'Sure?',
    deleteButtonTitle: 'Remove the matching',
    remove: 'Remove',
});
